import { render, staticRenderFns } from "./AccountCenter.vue?vue&type=template&id=6aefd4eb&scoped=true&"
import script from "./AccountCenter.vue?vue&type=script&lang=js&"
export * from "./AccountCenter.vue?vue&type=script&lang=js&"
import style0 from "./AccountCenter.vue?vue&type=style&index=0&id=6aefd4eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefd4eb",
  null
  
)

export default component.exports